import { Star } from "lucide-react";
import Reveal from "../Reveal";
import { TESTIMONIALS } from "../../lib/site";

export default function Testimonials({ city }) {
  const items = TESTIMONIALS;
  return (
    <section data-testid="testimonials" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-12 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Loved by homeowners</p>
          <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-forest md:text-5xl">
            {city ? `${city} families are switching to solar.` : "Thousands are already saving with Synergy."}
          </h2>
        </Reveal>
        <div className="grid gap-6 md:grid-cols-2">
          {items.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="flex h-full flex-col rounded-3xl border border-line bg-white/60 p-8">
                <div className="mb-4 flex items-center gap-3">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, j) => <Star key={j} className="h-4 w-4 fill-gold text-gold" />)}
                  </div>
                  {t.google && (
                    <span className="rounded-full bg-sand px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-moss">Google review</span>
                  )}
                </div>
                <p className="flex-1 text-lg leading-relaxed text-ink">"{t.quote}"</p>
                <div className="mt-6 flex items-center gap-3 border-t border-line pt-5">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full bg-forest font-heading text-sm font-bold text-cream">
                    {t.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
                  </div>
                  <div>
                    <p className="font-heading font-bold text-forest">{t.name}</p>
                    <p className="font-mono text-xs uppercase tracking-widest text-moss">{t.city}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
